function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { cssVar, Tooltip as ChakraTooltip, forwardRef } from "../chakra/internal";
import { getTypographyStyles } from "../typography/utils";
const $bg = cssVar('tooltip-bg');
const $arrowBg = cssVar('popper-arrow-bg');
const baseStyle = _object_spread_props(_object_spread({
    [$bg.variable]: 'colors.background.neutral.inverse.default',
    p: 'spacing.m',
    bg: [
        $bg.reference
    ],
    [$arrowBg.variable]: [
        $bg.reference
    ],
    color: 'text.neutral.inverse.default',
    borderRadius: 's'
}, getTypographyStyles('body.2xs.default')), {
    maxW: '320px',
    zIndex: 'tooltip',
    _dark: {
        color: 'text.neutral.inverse.default',
        [$bg.variable]: 'colors.background.neutral.inverse.default'
    }
});
export const ThemedTooltip = {
    baseStyle
};
const PLACEMENT_RADIUS_HORIZONTAL = {
    'top-start': '3px 0',
    top: '3px 0',
    'top-end': '3px 0',
    'right-start': '0 3px',
    right: '0 3px',
    'right-end': '0 3px',
    'left-start': '0 3px',
    left: '0 3px',
    'left-end': '0 3px'
};
const Tooltip = forwardRef((_param, ref)=>{
    var { sx, children } = _param, props = _object_without_properties(_param, [
        "sx",
        "children"
    ]);
    let radius = '3px 0 0 3px';
    if (props.placement) {
        radius = PLACEMENT_RADIUS_HORIZONTAL[props.placement] || radius;
    }
    return /*#__PURE__*/ _jsx(ChakraTooltip, _object_spread_props(_object_spread({
        sx: _object_spread_props(_object_spread({}, sx), {
            '.chakra-tooltip__arrow': {
                borderRadius: radius
            }
        }),
        ref: ref
    }, props), {
        children: children
    }));
});
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
    hasArrow: true,
    openDelay: 600
};
export { Tooltip };

//# sourceMappingURL=Tooltip.js.map